/**
 * @generated SignedSource<<90e87cc9dc72730e496be415a72c7cec>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MyPageProfile$data = {
  readonly avatarUrl: string | null;
  readonly profile: {
    readonly commonName: string | null;
  };
  readonly " $fragmentType": "MyPageProfile";
};
export type MyPageProfile$key = {
  readonly " $data"?: MyPageProfile$data;
  readonly " $fragmentSpreads": FragmentRefs<"MyPageProfile">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MyPageProfile",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "avatarUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "InfluencerInfo",
      "kind": "LinkedField",
      "name": "profile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "commonName",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Influencer",
  "abstractKey": null
};

(node as any).hash = "7ff266ae11e7fc96f4e7868496fa79c8";

export default node;
